<template>
  <div class="page">
    <el-dialog
      title="Voucher VIP"
      center
      class="vip"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
    >
    <div class="page_box">
      <!-- <div class="vip_level_nav">VIP优惠券</div> -->
      <div class="vip_level_dec">
        Khi thăng cấp độ VIP, Hệ thống sẽ tự động gửi  voucher đến tài khoản, Voucher VIP như nhau:
      </div>
      <div class="vip_level_table">
        <div class="vip_level_tr">
          <div class="vip_level_tb">Cấp VIP</div>
          <div class="vip_level_tb">Voucher VIP</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">1</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng thường*1</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">2</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng thường*2</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">3</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng thường*3</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">4</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng cao cấp*1</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">5</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng cao cấp*2</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">6</div>
          <div class="vip_level_tb">Quà voucher nạp đủ tặng cao cấp*3</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">7</div>
          <div class="vip_level_tb">Quà voucher nạp đủ giảm đặc biệt*1</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">8</div>
          <div class="vip_level_tb">Quà voucher nạp đủ giảm đặc biệt*2</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">9</div>
          <div class="vip_level_tb">Quà voucher nạp đủ giảm đặc biệt*3</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">10</div>
          <div class="vip_level_tb">Lễ bao ưu đãi chí tôn*1</div>
        </div>
      </div>
      <div class="vip_level_dec">
        <span class="vip_level_coupon">Quà voucher nạp đủ tặng thường：</span> 22000 Tặng 4000*1，109000 Tặng 22000*1
      </div>
      <div class="vip_level_dec">
        <span class="vip_level_coupon">Quà voucher nạp đủ tặng cao cấp：</span> 109000 Tặng 24000*1，699000 Tặng 210000*1
      </div>
      <div class="vip_level_dec">
        <span class="vip_level_coupon">Quà voucher nạp đủ tặng đặc biệt：</span> 1099000 Tặng 350000*1，2199000 Tặng 800000*1
      </div>
      <div class="vip_level_dec">
        <span class="vip_level_coupon"> Lễ bao ưu đãi chí tôn：</span>1099000 Tặng 500000*3，2199000 Tặng 1000000*3
      </div>
    </div>
    </el-dialog>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogFormVisible:false,
    };
  },
  methods: {
    handleClose() {
      this.$parent.dialogFormVisible = true;
      this.dialogFormVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
$vip-color: #409EFF;
div{
  white-space: pre-wrap;
  word-break: break-word;
}
/deep/.el-dialog {
  width: 700px;
}
.page_box {
  padding: 0 3.52px 16px 3.52px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.vip_level_nav {
  padding: 5px 65px;
  border: 1px solid $vip-color;
  color: $vip-color;
  border-radius: 30px;
  text-align: center;
  margin: 0 auto;
  width: 100px;
  font-size: 18px;
}
.vip_level_img {
  margin: 4.8px 0;
}
.vip_level_dec {
  line-height: 32px;
  font-size: 16px;
}
.vip_level_coupon{
  font-weight: bold;
}
.vip_level_table {
  margin-top: 4.8px;
  width: 95%;
  border-left: .0625rem solid #ddd;
  border-bottom: .0625rem solid #ddd;
}
.vip_level_tr {
  display: flex;
}
.vip_level_tr:nth-child(1) {
  background-color: $vip-color;
}
.vip_level_tr:nth-child(1) .vip_level_tb {
  min-height: 32px;
  color: #fff;
}
.vip_level_tb {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 32px;
  font-size: 16px;
  border-top: .0625rem solid #ddd;
  border-right: .0625rem solid #ddd;
}
@media screen and (max-width: 1000px) {
  /deep/.el-dialog {
    width: 95%;
  }
}
</style>